import { Link } from "react-router-dom";
import { LinkedinLogo, List } from "@phosphor-icons/react";
import { Logo } from "@/components/Logo";
import { CookieSettingsLink } from "@/components/legal/CookieConsent";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

const MobileMenu = ({ home }) => {
  const links = [
    ["Features", home ? "#features" : "/features", "features"], ["Pricing", home ? "#pricing" : "/pricing", "pricing"],
    ["See the dashboard", home ? "#walkthrough" : "/#walkthrough", "dashboard"], ["Security", "/security", "security"], ["About", "/about", "about"],
  ];
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger data-testid="mobile-menu-btn" aria-label="Open menu"
        className="md:hidden h-10 w-10 grid place-items-center rounded-full border border-[#2A2A2A] hover:border-white transition-colors"><List size={18} /></DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={8} data-testid="mobile-menu" className="w-56 bg-[#0A0A0A] border-[#2A2A2A] text-white p-1">
        {links.map(([label, href, id]) => (
          <DropdownMenuItem key={id} asChild className="focus:bg-[#121212] focus:text-white py-2.5 text-sm cursor-pointer">
            {href.startsWith("/") && !href.includes("#") ? <Link to={href} data-testid={`mobile-menu-${id}`}>{label}</Link> : <a href={href} data-testid={`mobile-menu-${id}`}>{label}</a>}
          </DropdownMenuItem>
        ))}
        <DropdownMenuItem asChild className="focus:bg-[#00FF9D] focus:text-[#050505] py-2.5 text-sm font-semibold text-[#00FF9D] cursor-pointer">
          <Link to="/sign-up" data-testid="mobile-menu-trial">Start 14-day free trial</Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export const FOUNDER = {
  name: "Sonia Montez",
  initials: "SM",
  title: "Founder, CalibRunway",
  company: "CalibRunway, a Nolasco Group Brand",
  why: "After decades of consulting for startup operations and building Excel sheets for founders, I created a streamlined solution that gives founders a simple, direct view of their cash flow reality and growth potential.",
  linkedin: "https://www.linkedin.com/in/sonia-montez/",
};

export const SiteNav = ({ home = false }) => (
  <header className="sticky top-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
      <Logo />
      <nav className="hidden md:flex items-center gap-8 text-sm text-[#A3A3A3]">
        <a href={home ? "#features" : "/features"} data-testid="nav-features-link" className="hover:text-white transition-colors">Features</a>
        <a href={home ? "#pricing" : "/pricing"} data-testid="nav-pricing-link" className="hover:text-white transition-colors">Pricing</a>
        <Link to="/security" data-testid="nav-security-link" className="hover:text-white transition-colors">Security</Link>
        <Link to="/about" data-testid="nav-about-link" className="hover:text-white transition-colors">About</Link>
      </nav>
      <div className="flex items-center gap-3">
        <Link to="/sign-in" data-testid="nav-signin-link" className="text-sm text-[#A3A3A3] hover:text-white transition-colors px-2 py-2 whitespace-nowrap">Sign in</Link>
        <a href={home ? "#walkthrough" : "/#walkthrough"} data-testid="nav-see-dashboard-btn"
          className="hidden sm:inline-flex rounded-full border border-[#00FF9D]/60 px-4 py-2 text-sm text-[#00FF9D] hover:bg-[#00FF9D] hover:text-[#050505] transition-colors whitespace-nowrap">See the dashboard</a>
        <MobileMenu home={home} />
      </div>
    </div>
  </header>
);

export const SiteFooter = () => (
  <footer data-testid="site-footer" className="border-t border-[#2A2A2A] py-8 px-6 mx-auto max-w-7xl flex flex-col md:flex-row gap-4 justify-between text-xs font-mono text-[#A3A3A3]">
    <span className="leading-relaxed">© {new Date().getFullYear()} {FOUNDER.company} · Built by{" "}
      <a href={FOUNDER.linkedin} target="_blank" rel="noopener noreferrer" data-testid="footer-founder-link" className="text-white hover:text-[#00FF9D] underline inline-flex items-center gap-1">
        {FOUNDER.name} <LinkedinLogo size={13} />
      </a>
    </span>
    <span className="flex flex-wrap gap-x-3 gap-y-2">
      <Link to="/about" data-testid="footer-about-link" className="hover:text-white underline">About</Link>
      <Link to="/security" data-testid="footer-security-link" className="hover:text-white underline">Security</Link>
      <a href="/terms" data-testid="footer-terms-link" className="hover:text-white underline">Terms</a>
      <CookieSettingsLink testid="footer-cookie-settings" />
    </span>
  </footer>
);
